if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
        constructor() {
            super();

            this.elInfoToggle = this.querySelector('[data-info-toggle]');
            this.elInfoOverlay = this.querySelector('[data-info-overlay]');
            this.elInfoClose = this.querySelector('[data-info-close]');
            this.elImage = this.querySelector('[data-image]');
            this.elHover = this.querySelector('[data-hover]');
            this.elVariantTitle = this.querySelector('[data-variant-title]');
            this.elVariantSelector = this.querySelector('variant-selector');
            this.elAtc = this.querySelector('[data-atc]');

            this.elCta = this.elAtc && this.elAtc.querySelector('[data-cta]');
            this.elCap = this.elAtc && this.elAtc.querySelector('[data-cap]');
            this.elPrice = this.elAtc && this.elAtc.querySelector('[data-price]');
            this.elUrl = this.querySelector('[data-url]');
        }

        connectedCallback() {
            this.elInfoToggle = this.querySelector('[data-info-toggle]');
            this.elInfoOverlay = this.querySelector('[data-info-overlay]');
            this.elInfoClose = this.querySelector('[data-info-close]');
            this.elImage = this.querySelector('[data-image]');
            this.elHover = this.querySelector('[data-hover]');
            this.elVariantTitle = this.querySelector('[data-variant-title]');
            this.elVariantSelector = this.querySelector('variant-selector');
            this.elAtc = this.querySelector('[data-atc]');
            if (this.elAtc && !this.atcClickListener) {
                this.atcClickListener = (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (this.elAtc.disabled) return;
                    const elCartDrawer = document.querySelector('cart-drawer');
                    elCartDrawer.addToCart(this.elAtc, {
                        id: Number(this.elAtc.getAttribute('data-id')),
                        quantity: 1,
                    });
                };
                this.elAtc.addEventListener('click', this.atcClickListener);
            }

            if (this.elInfoOverlay) {
                this.elInfoOverlay.setAttribute('hidden', '');
                this.elInfoToggle && this.elInfoToggle.setAttribute('aria-expanded', 'false');
            }

            if (this.elInfoToggle && this.elInfoOverlay && !this.infoToggleListener) {
                this.infoToggleListener = (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    this.toggleInfoOverlay();
                };
                this.elInfoToggle.addEventListener('click', this.infoToggleListener);
            }

            if (this.elInfoClose && this.elInfoOverlay && !this.infoCloseListener) {
                this.infoCloseListener = (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    this.setInfoOverlayOpen(false);
                };
                this.elInfoClose.addEventListener('click', this.infoCloseListener);
            }
            this.elCta = this.elAtc && this.elAtc.querySelector('[data-cta]');
            this.elCap = this.elAtc && this.elAtc.querySelector('[data-cap]');
            this.elPrice = this.elAtc && this.elAtc.querySelector('[data-price]');
            this.elUrl = this.querySelector('[data-url]');

            if (this.elVariantSelector && !this.variantChangeListener) {
                this.variantChangeListener = this.updateCurrentVariant.bind(this);
                this.elVariantSelector.addEventListener(
                    'variant:changed',
                    this.variantChangeListener,
                );
            }
        }

        toggleInfoOverlay() {
            this.setInfoOverlayOpen(!this.elInfoOverlay.classList.contains('open'));
        }

        setInfoOverlayOpen(open) {
            if (open) {
                this.elInfoOverlay.ontransitionend = null;
                this.elInfoOverlay.removeAttribute('hidden');
                this.elInfoOverlay.classList.add('visible');
                requestAnimationFrame(() => {
                    this.elInfoOverlay.classList.add('open');
                });
                this.elInfoToggle && this.elInfoToggle.setAttribute('aria-expanded', 'true');
            } else {
                this.elInfoToggle && this.elInfoToggle.setAttribute('aria-expanded', 'false');
                this.elInfoOverlay.classList.remove('open');
                this.elInfoOverlay.ontransitionend = (ev) => {
                    if (ev.target !== this.elInfoOverlay || ev.propertyName !== 'opacity') return;
                    this.elInfoOverlay.classList.remove('visible');
                    this.elInfoOverlay.setAttribute('hidden', '');
                    this.elInfoOverlay.ontransitionend = null;
                };
            }
        }

        updateCurrentVariant(ev) {
            const { detail: variant } = ev;

            if (!variant) return;

            this.elVariantTitle.innerHTML = variant.title;
            this.elPrice.innerHTML = variant.price;
            if (
                variant.available &&
                variant.inventory_policy == 'continue' &&
                variant.inventory_quantity < 1
            ) {
                this.elCta.innerHTML = 'Add to Cart';
            } else if (variant.available) {
                this.elCta.innerHTML = 'Add to Cart';
            } else {
                this.elCta.innerHTML = 'Sold Out';
            }

            variant.cap && (this.elCap.innerHTML = variant.cap);
            this.elCap.toggleAttribute('hidden', !variant.cap);

            this.elAtc.setAttribute('data-id', variant.id);
            this.elAtc.toggleAttribute('disabled', !variant.available);

            this.elUrl.setAttribute('href', variant.url);
            this.elUrl.innerHTML = `View more information about ${variant.title}`;

            void this.#updateVariantImages(variant);
        }

        async #updateVariantImages(variant) {
            if (variant.media[0]) {
                await this.#swapImageContainer(this.elImage, variant.media[0].tag);
            }

            if (variant.media[1]) {
                await this.#swapImageContainer(this.elHover, variant.media[1].tag);
            }

            this.classList.toggle('has-hover', !!variant.media[1]);
        }

        async #swapImageContainer(container, htmlString) {
            const staged = document.createElement('div');
            staged.innerHTML = htmlString;
            const img = staged.querySelector('img');

            if (!img) {
                container.innerHTML = htmlString;
                return;
            }

            img.loading = 'eager';
            await ProductCard.#whenImageDecoded(img);

            if (!img.naturalWidth) return;

            container.replaceChildren(img);
        }

        static async #whenImageDecoded(img) {
            if (!img.complete) {
                await new Promise((resolve) => {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            }

            if (img.decode) {
                try {
                    await img.decode();
                } catch (_) {}
            }
        }
    }

    customElements.define('product-card', ProductCard);
}
